import type { FaireProductEntity } from "../../entity_types/product";

export const p_udazh498tp: FaireProductEntity = {
  token: "p_udazh498tp",
  type: "product",
  name: "Book Lover Dishcloth Set",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/a944ef49dda911cafbfbe9052523a3bce363be74b186d47e92c0c567600a4778.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4278724057daeb9fa1d63e8d98c840517b6160762c17f98ca68c547dd9aa1aec.jpeg"
  ],
  priceDollars: 7,
  description: "Dishcloth Set - 3 Pack\n\nDish it out. \n\nOur Dishcloths are everything you love about the original Geometry Kitchen Towel – in mini-size! Scrub, wipe, shine and repeat – our fast-drying, super-absorbent dishtowels can handle your biggest messes with ease (and a whole lot of style). Created from our signature Geoweave(™) fabric, perfect for surface cleaning and shining. Sold as a set of 3.\n\n...\n\n * ♺ Made from post-consumer recycled materials \n * 10\" x 10\" \n * Single-sided print \n * Sold as a set of 3 \n * 100% Satisfaction Guarantee \n * No questions asked, hassle-free returns \n...\n\nChore responsibly. \n\nFrom scrubbing pots and pans to wiping up spills to accenting your kitchen with the season’s most captivating prints, our Dishcloth Sets will be your constant companion – and they’re a friend to the environment too. Our towels are created from post-consumer recycled products and manufactured using less water than traditional methods, minimizing our carbon footprint. And due to its patented weave, high absorbency and quick dry time, you can clean with fewer harsh chemicals and wash it less often, reducing yours. \n",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:45.465Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
